export default "__VITE_ASSET__54a93a28__"